<template>
  <v-col cols="12">
    <Loader
      v-if="loading"
      :key="generateUniqueId()"
      :loader-state="loading"
    ></Loader>

    <v-card>
      <v-card-title>Offres injectées</v-card-title>

      <v-card-text>
        <div class="global-actions">
          <router-link :to="{ name: 'specialOfferCreate' }">
            <v-btn
              small
              color="primary"
              class="mt-5"
            >
              Ajouter une offre spéciale
            </v-btn>
          </router-link>
        </div>
      </v-card-text>

      <div class="clear"></div>

      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-uppercase">
                Nom
              </th>
              <th class="text-center text-uppercase">
                Position
              </th>
              <th class="text-center text-uppercase">
                Home
              </th>
              <th class="text-center text-uppercase">
                Menu
              </th>
              <th class="text-center text-uppercase">
                Etat
              </th>
              <th class="text-center text-uppercase">
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(specialOffer, specialOfferIndex) in specialOffers"
              :key="'e' + specialOfferIndex"
            >
              <td class="font-weight-bold">
                {{ resolveAttrValue(specialOffer, 'name') }}
              </td>
              <td class="text-center">
                {{ specialOffer.position }}
              </td>
              <td class="text-center">
                <v-chip
                  v-if="specialOffer.onHome"
                  color="success"
                  text-color="white"
                  small
                >
                  Oui
                </v-chip>
                <v-chip
                  v-else
                  color="error"
                  text-color="white"
                  small
                >
                  Non
                </v-chip>
              </td>
              <td class="text-center">
                <v-chip
                  v-if="specialOffer.inMenu"
                  color="success"
                  text-color="white"
                  small
                >
                  Oui
                </v-chip>
                <v-chip
                  v-if="!specialOffer.inMenu"
                  color="error"
                  text-color="white"
                  small
                >
                  Non
                </v-chip>
              </td>
              <td class="text-center">
                <v-chip
                  v-if="specialOffer.enabled"
                  color="success"
                  text-color="white"
                  small
                >
                  Activé
                </v-chip>
                <v-chip
                  v-if="!specialOffer.enabled"
                  color="error"
                  text-color="white"
                  small
                >
                  Désactivé
                </v-chip>
              </td>
              <td class="text-center">
                <v-tooltip top>
                  <template #activator="{ on, attrs }">
                    <v-btn
                      color="warning"
                      fab
                      dark
                      x-small
                      v-bind="attrs"
                      :to="{ name: 'specialOfferDetails', params: { specialOfferId: specialOffer.id }}"
                    >
                      <v-icon dark>
                        {{ icons.mdiEye }}
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Consulter</span>
                </v-tooltip>

                <v-tooltip top>
                  <template #activator="{ on, attrs }">
                    <v-btn
                      class="ml-2"
                      color="error"
                      fab
                      dark
                      x-small
                      v-bind="attrs"
                      @click="openDeleteSpecialOfferDialog(specialOffer)"
                    >
                      <v-icon dark>
                        {{ icons.mdiTrashCan }}
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Supprimer</span>
                </v-tooltip>
              </td>
            </tr>
          </tbody>
          <tbody v-if="!specialOffers.length">
            <tr>
              <td>
                <span v-if="loading === false">Aucun éléments.</span>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>

      <DeleteSpecialOfferDialog
        :key="Date.now()"
        :delete-special-offer-dialog-state="deleteSpecialOfferDialogState"
        :special-offer="specialOfferToDelete"
        @closeDeleteSpecialOfferDialog="closeDeleteSpecialOfferDialog($event)"
      ></DeleteSpecialOfferDialog>
    </v-card>
  </v-col>
</template>

<script>
import { mdiPlay, mdiPen, mdiEye, mdiTrashCan } from '@mdi/js'
import Vue from 'vue'
import DeleteSpecialOfferDialog from '@/components/Dialog/SpecialOfferDialog/DeleteSpecialOfferDialog.vue'
import config from '../../../config'
import Loader from '@/components/Common/Loader.vue'

export default {
  components: {
    DeleteSpecialOfferDialog,
    Loader
  },
  data: () => ({
    specialOffers: [],
    specialOfferToDelete: null,
    deleteSpecialOfferDialogState: false,
    loading: false,
    icons: {
      mdiPlay,
      mdiPen,
      mdiEye,
      mdiTrashCan
    }
  }),
  created () {
    this.getSpecialOffers()
  },
  methods: {
    getSpecialOffers () {
      this.loading = true

      const params = {
        limit: 150
      }

      Vue.prototype.$http
        .get(config.apiUrl + '/api/special-offer/super-categories', {
          headers: {
            Authorization: 'Bearer ' + this.$store.getters.getToken
          },
          params: params
        })
        .then(response => {
          if (response.status === 200) {
            const data = response.data

            if (data) {
              this.specialOffers = data
            }
          }

          this.loading = false
        })
        .catch(e => {
          const response = e.response

          if (response.status === 400 || response.status === 404) {
            const data = response.data
            this.errors = data.violations
          }

          this.valid = true
          this.loading = false
        })
    },
    openDeleteSpecialOfferDialog (specialOffer) {
      this.deleteSpecialOfferDialogState = true
      this.specialOfferToDelete = specialOffer
    },
    closeDeleteSpecialOfferDialog (deleteState) {
      if (deleteState === true) {
        this.specialOffers = this.specialOffers.filter(element => element.id !== this.specialOfferToDelete.id)
      }

      this.deleteSpecialOfferDialogState = false
    },
    resolveAttrValue (data, attr) {
      const translations = data.translations

      if (translations.fr) {
        return translations.fr[attr]
      }

      return '-'
    }
  }
}
</script>
